import React from "react";
import PropTypes from "prop-types";
import { CustomSelect } from "../../../../commons/index";

/**
 * Makes Select Boxes safe to objects with missing label. When Loading page we have Id but not name which is fetched
 * lazy, so we prevent update if id is know but name not
 */
export default class CustomSelectNullSafe extends React.Component {

    static propTypes = {
        label: PropTypes.string,
        value: PropTypes.any,
        onChange: PropTypes.func.isRequired,
        multi: PropTypes.bool,
        async: PropTypes.bool,
        debounceTime: PropTypes.number,
        options: PropTypes.array,
        loadOptions: PropTypes.func,
        noResultsText: PropTypes.string,
        searchPromptText: PropTypes.string,
        searchingText: PropTypes.string
    };

    static defaultProps = {
        options: []
    };

    shouldComponentUpdate = (newProps) => {
        // Dont re-render if we have a label and want to update to empty string
        if( this.props.value
            && this.props.value[this.props.labelKey] !== ""
            && newProps.value && newProps.value[newProps.labelKey] === ""){
            return false;
        }
        // Dont re-render if value is the same, both cases are null for example
        if(this.props.value === newProps.value){
            return false;
        }
        return true;
    };

    render = () => {
        return <CustomSelect
            async debounceTime={this.props.debounceTime}
            aria-label={this.props.ariaLabel}
            placeholder={this.props.placeholder}
            value={this.props.value}
            onChange={this.props.onChange}
            loadOptions={this.props.loadOptions}
            valueKey={this.props.valueKey}
            labelKey={this.props.labelKey}
            minimumInput={this.props.minimumInput}
            noResultsText={this.props.noResultsText}
            searchPromptText={this.props.searchPromptText}
            searchingText={this.props.searchingText}
        />
    };
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/pages/search/desktop/CustomSelectNullSafe.jsx